import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appAllowOnlyNumber]',
  standalone: false
})
export class AllowOnlyNumberDirective {

  // Allow only digits
  private readonly NUMBER_REGEXP = /^[0-9]*$/;

  constructor() {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    const allowedControlKeys: string[] = [
      'Backspace',
      'Delete',
      'Tab',
      'Escape',
      'Enter',
      'ArrowLeft',
      'ArrowRight',
      'Home',
      'End'
    ];

    // Allow control keys
    if (allowedControlKeys.includes(event.key)) {
      return;
    }

    // Prevent non-numeric keys
    if (!this.NUMBER_REGEXP.test(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    const clipboardData: DataTransfer = event.clipboardData;
    const pastedText: string = clipboardData?.getData('text') ?? '';

    if (!this.NUMBER_REGEXP.test(pastedText)) {
      event.preventDefault();
    }
  }
}
